import i18n from '../../../lib/i18n';
import BranchStatus from '../enums/branch-status.enum';
import {
    IGetBranchModalMessage,
    ModalAction,
} from './interfaces/IGetBranchModalMessage';

export default function getMessageModalBranch(data: IGetBranchModalMessage) {
    let message = '**';
    const branchesCount = data.branches.length;

    const names = data.branches.map(l => l.corporateName);
    const status = data.branches.map(l => l.branchStatus);

    if (branchesCount > 3) {
        const threeFirstNames = names.slice(0, 3);
        threeFirstNames.forEach((name, index) => {
            message += name;
            message += index === 2 ? ' e ' : ', ';
        });

        message += `${branchesCount - 3} outras`;
    } else if (branchesCount === 1) {
        message += names[0];
    } else {
        message += names.join(', ');
    }

    message += '**';

    if (
        data.action === ModalAction.approve &&
        status.some(s => s !== BranchStatus.requested)
    ) {
        message += `.-&-& ${i18n.t('BranchModalActionApprove')}`;
    } else if (
        data.action === ModalAction.reprove &&
        status.some(s => s !== BranchStatus.approved)
    ) {
        message += `.-&-& ${i18n.t('BranchModalActionReprove')}`;
    }

    return message;
}
